import styled from 'styled-components';
import { colors } from "../../../../utils/colors";

export const ProductWrapper = styled.div`
    margin-top: 50px;
    width: 100%;
    max-width: 400px;
    background-color: ${colors.WHITE};
    border-radius: 5px;
    padding: 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                0 3px 4px 0 rgba(0,0,0,.14),
                0 1px 8px 0 rgba(0,0,0,.12);
`;

export const NoFavoritesText = styled.p`
    color: ${colors.BLUE};
    margin-bottom: 20px;
    text-align: center;
`;
